import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNetworkWifi = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.9999 20.575C11.8666 20.575 11.7416 20.554 11.6249 20.512C11.5082 20.4707 11.3999 20.4 11.2999 20.3L0.699893 9.7C0.499893 9.5 0.404227 9.26233 0.412893 8.987C0.420893 8.71233 0.524893 8.48333 0.724893 8.3C2.29156 6.88333 4.03756 5.81267 5.96289 5.088C7.88756 4.36267 9.89989 4 11.9999 4C14.1166 4 16.1372 4.36267 18.0619 5.088C19.9872 5.81267 21.7249 6.88333 23.2749 8.3C23.4749 8.48333 23.5792 8.71233 23.5879 8.987C23.5959 9.26233 23.4999 9.5 23.2999 9.7L12.6999 20.3C12.5999 20.4 12.4916 20.4707 12.3749 20.512C12.2582 20.554 12.1332 20.575 11.9999 20.575ZM4.34989 10.5C5.43323 9.71667 6.62089 9.104 7.91289 8.662C9.20423 8.22067 10.5666 8 11.9999 8C13.4332 8 14.7959 8.22067 16.0879 8.662C17.3792 9.104 18.5666 9.71667 19.6499 10.5L21.0999 9.05C19.7999 8.06667 18.3792 7.31233 16.8379 6.787C15.2959 6.26233 13.6832 6 11.9999 6C10.3166 6 8.70389 6.26233 7.16189 6.787C5.62056 7.31233 4.19989 8.06667 2.89989 9.05L4.34989 10.5Z",
		fill: "currentColor"
	})
});
export default SvgNetworkWifi;
